
export default {
    CMS: 'CMS',
    HOME: 'HOME',
    AWAY: 'AWAY',
    NETWORK: 'NETWORK',
    WORLD: 'WORLD',
    REEL: 'REEL',
    UNKNOWN: 'UNKNOWN',
};
